import React from 'react';

import '../stylesheets/Button.scss';

export default function Button(props) {
  return (
    <div className="button-container" style={{ width: props.width, height: props.height }}>
      <a href={props.link} target="_blank" rel="noopener noreferrer">
        <div className="button">{props.message}</div>
      </a>
    </div>
  );
}
